import { useSearchParams } from 'react-router';

import { SetTemplateLanguageOptions, TEMPLATE_LIST_PARAM } from '../config';

export const useTemplateLanguageParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const language =
    searchParams.get(TEMPLATE_LIST_PARAM.language)?.trim() || null;

  const setLanguage = (value: string, options?: SetTemplateLanguageOptions) => {
    setSearchParams(
      (previous) => {
        const next = new URLSearchParams(previous);

        if (!value) {
          next.delete(TEMPLATE_LIST_PARAM.language);
        } else {
          next.set(TEMPLATE_LIST_PARAM.language, value);
        }

        if (options?.resetSpecialty) {
          next.delete(TEMPLATE_LIST_PARAM.specialty);
        }

        return next;
      },
      { replace: true },
    );
  };

  return { language, setLanguage };
};
